import { useState } from 'react'
import { milestones, products as productConfigs } from '../data/milestones'
import { getAlerts } from '../data/milestones'

const ALERT_SEVERITY = {
  overdue: { color: '#EF4444', bg: 'rgba(239,68,68,0.08)', border: 'rgba(239,68,68,0.2)', icon: '🔴', label: 'متأخر' },
  warning: { color: '#F59E0B', bg: 'rgba(245,158,11,0.08)', border: 'rgba(245,158,11,0.2)', icon: '🟡', label: 'تحذير — خلال ٢٤ ساعة' },
}

export default function AlertBanner() {
  const [expanded, setExpanded] = useState(false)
  const alerts = getAlerts(milestones)

  if (alerts.length === 0) return null

  const overdueCount = alerts.filter(a => a.severity === 'overdue').length
  const warningCount = alerts.filter(a => a.severity === 'warning').length

  return (
    <div className="mb-6 animate-fade-in-up" style={{ opacity: 0 }}>
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full text-right"
      >
        <div className="relative overflow-hidden rounded-[14px] border border-red-500/20 p-4"
          style={{ backgroundColor: overdueCount > 0 ? 'rgba(239,68,68,0.06)' : 'rgba(245,158,11,0.06)' }}>
          <div className="absolute top-0 inset-x-0 h-[2px]"
            style={{ background: overdueCount > 0 ? 'linear-gradient(90deg, #EF4444, #F87171)' : 'linear-gradient(90deg, #F59E0B, #FCD34D)' }} />

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="relative">
                <span className="text-2xl">{overdueCount > 0 ? '🚨' : '⚠️'}</span>
                <span className="absolute -top-1 -right-2 w-5 h-5 rounded-full text-[10px] font-bold text-white flex items-center justify-center"
                  style={{ backgroundColor: overdueCount > 0 ? '#EF4444' : '#F59E0B' }}>
                  {alerts.length}
                </span>
              </div>
              <div>
                <p className="text-sm font-bold text-[#F1F5F9]">
                  {overdueCount > 0 && warningCount > 0
                    ? `${overdueCount} متأخر + ${warningCount} تحذير`
                    : overdueCount > 0
                      ? `${overdueCount} مهمة متأخرة`
                      : `${warningCount} تحذير — خلال ٢٤ ساعة`}
                </p>
                <p className="text-[11px] text-[#94A3B8] mt-0.5">
                  {overdueCount > 0 ? 'مهام تجاوزت تاريخ التسليم' : 'مهام تنتهي خلال ٢٤ ساعة'}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              {overdueCount > 0 && (
                <span className="px-2 py-1 rounded-full text-[10px] font-bold bg-red-500/15 text-red-400 border border-red-500/20 animate-pulse">
                  {overdueCount} متأخر
                </span>
              )}
              {warningCount > 0 && (
                <span className="px-2 py-1 rounded-full text-[10px] font-bold bg-amber-500/15 text-amber-400 border border-amber-500/20">
                  {warningCount} تحذير
                </span>
              )}
              <svg
                className={`w-4 h-4 text-[#64748B] transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
                fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
      </button>

      {/* Expanded alert list */}
      {expanded && (
        <div className="mt-2 space-y-2">
          {alerts.map((alert, i) => {
            const sev = ALERT_SEVERITY[alert.severity]
            const pc = productConfigs[alert.product]
            return (
              <div
                key={i}
                className="rounded-[12px] border p-3 flex items-start gap-3"
                style={{ backgroundColor: sev.bg, borderColor: sev.border }}
              >
                <span className="text-lg mt-0.5">{sev.icon}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-bold text-[#F1F5F9]">{alert.taskName}</span>
                    <span className="px-1.5 py-0.5 rounded-full text-[9px] font-bold"
                      style={{ backgroundColor: sev.bg, color: sev.color, border: `1px solid ${sev.border}` }}>
                      {sev.label}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 mt-1 flex-wrap">
                    <span className="text-[11px] text-[#94A3B8]">{pc?.icon} {alert.milestoneName}</span>
                    <span className="text-[11px] text-[#94A3B8]">📅 {alert.dueDate}</span>
                    {alert.daysOverdue !== undefined && (
                      <span className="text-[11px] font-bold" style={{ color: sev.color }}>
                        {alert.daysOverdue > 0 ? `${alert.daysOverdue} يوم تأخير` : 'اليوم'}
                      </span>
                    )}
                    {alert.hoursRemaining !== undefined && (
                      <span className="text-[11px] font-bold" style={{ color: sev.color }}>
                        {alert.hoursRemaining} ساعة متبقية
                      </span>
                    )}
                    {alert.assignee && alert.assignee !== '—' && (
                      <span className="text-[11px] text-[#94A3B8]">🤖 {alert.assignee}</span>
                    )}
                  </div>
                  {alert.notes && (
                    <p className="text-[10px] text-[#94A3B8] mt-1">{alert.notes}</p>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
